import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { startWith } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppRouterService {

  private readonly _router = inject(Router);

  private _staticRoutes: Readonly<string[]> = [
    '/auth/action'
  ] as const;

  route$ = this._router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    map((event: NavigationEnd) => event.urlAfterRedirects),
    startWith(this._router.url)
  );

  isStaticRoute$ = this.route$.pipe(
    map((route) => this._staticRoutes.includes(route))
  );
}
